import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const NOTIFICATIONS_API_URL =
  process.env.REACT_APP_NOTIFICATIONS_API_URL || buildApiUrl('/notifications');

export async function fetchNotificationSummary() {
  const response = await fetch(`${NOTIFICATIONS_API_URL}/summary`, {
    headers: withBusinessHeaders(),
  });

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || 'Unable to load notifications right now.');
  }

  return response.json();
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
